/* ---------- READ FLAVORS DATA FROM DIV ---------- */
const flavorsList = document.getElementById("flavors_div") || document.getElementById("flavors_div_dev");
const rawFlavorsData = flavorsList ? flavorsList.getAttribute("flavors") : null;
let validFlavorsData = [];

if (rawFlavorsData) {
  try {
    // Try to parse the JSON directly first
    validFlavorsData = JSON.parse(rawFlavorsData);
  } catch (e) {
    console.log("Initial JSON parse failed, trying to clean data...");
    console.log("Raw data:", rawFlavorsData);

    // If that fails, try to clean it up
    try {
      let cleanedData = rawFlavorsData;

      // Handle various quote encodings
      cleanedData = cleanedData.replace(/'/g, "’");

      console.log("Cleaned data:", cleanedData);
      validFlavorsData = JSON.parse(cleanedData);
    } catch (e2) {
      console.error("Failed to parse flavors data after cleaning:", e2);
      console.error("Original error:", e);
      validFlavorsData = [];
    }
  }
}

/* ---------- HELPER ---------- */
const $all = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

function updateTickContent(stepElement, isCompleted) {
  const tickElement = stepElement.querySelector(".tick");
  if (tickElement) {
    if (isCompleted) {
      tickElement.innerHTML =
        '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" fill="currentColor"/></svg>';
    } else {
      tickElement.innerHTML = "";
    }
  }
}

function showError(message, upgradeText = null, upgradeAction = null) {
  const err = document.querySelector(".luuf-error");
  const promptWarning = document.querySelector(".luuf-prompt-warning");

  const content =
    upgradeText && upgradeAction
      ? `<div style="margin-bottom: 8px;">${message}</div>
       <div style="cursor: pointer; text-decoration: underline; font-size: 12px; color: #1a5f1a;" onclick="${upgradeAction}">${upgradeText}</div>`
      : message;

  // Update main error element
  if (upgradeText && upgradeAction) {
    err.innerHTML = content;
  } else {
    err.textContent = message;
  }

  err.classList.remove("discount-upgrade");
  err.style.display = "block";
  err.style.color = "#d33";
  err.style.background = "#ffe6e6";
  err.style.padding = "8px 12px";
  err.style.borderRadius = "6px";
  err.style.border = "1px solid #ffcccc";
  err.style.fontWeight = "600";

  // Distinguish between "select first" errors and "upgrade" errors based on message content
  const isSelectFirstError = message.includes("נא לבחור");
  const isUpgradeError = message.includes("ניתן לבחור עד");

  if (isSelectFirstError) {
    // This is a "select period/device first" type error - show mobile prompt
    if (promptWarning) {
      if (upgradeText && upgradeAction) {
        promptWarning.innerHTML = content;
      } else {
        promptWarning.textContent = message;
      }
      promptWarning.style.display = "block";
    }

    // Force show mobile type selection prompt on mobile when there's a "select first" error
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      const typePrompt = document.querySelector(".luuf-type-selection-prompt");
      if (typePrompt) {
        typePrompt.classList.add("show");
      }
    }
  } else if (isUpgradeError) {
    // This is an "upgrade" error - hide mobile prompt since period & device are selected
    if (promptWarning) {
      promptWarning.style.display = "none";
    }
    const typePrompt = document.querySelector(".luuf-type-selection-prompt");
    if (typePrompt) {
      typePrompt.classList.remove("show");
    }
  }
}

// Helper function to silently select a period (without animations)
function selectPeriodSilently(targetPeriodNumber) {
  const periodCards = document.querySelectorAll("#luuf-step1 .luuf-device");
  periodCards.forEach((card) => {
    const title = card.querySelector("h4").textContent;
    const periodNumber = parseInt(title.split(" ")[0]);

    if (periodNumber === targetPeriodNumber) {
      // Only update if period actually changed
      if (selectedPackSize !== periodNumber) {
        // Update UI without triggering animations
        periodCards.forEach((c) => {
          c.classList.remove("selected");
          const b = c.querySelector("button");
          b.textContent = b.textContent.replace("נבחר", "בחירה");
        });

        card.classList.add("selected");
        const btn = card.querySelector("button");
        btn.textContent = btn.textContent.replace("בחירה", "נבחר");
        selectedPeriod = title;
        selectedPackSize = periodNumber;

        // Update step text
        const step1 = document.querySelector('[data-target="#luuf-step1"]');
        const step1Text = step1.querySelector(".step-text");
        if (step1Text) {
          step1Text.textContent = `1. בחירת תקופת גמילה - ${title}`;
        }
        step1.classList.add("completed");
        updateTickContent(step1, true);

        // Save state
        saveState();

        // Update summary and prompts (but skip animations)
        updateSummary();
        updateTypeSelectionPrompt();

        // Mark that this was an automatic change (not manual)
        periodManuallySelected = false;
      }
    }
  });
}

// Helper function to automatically upgrade period
function autoUpgradePeriod() {
  const currentPeriod = selectedPackSize;
  let nextPeriod = null;

  if (currentPeriod === 3) {
    nextPeriod = 6;
  } else if (currentPeriod === 6) {
    nextPeriod = 12;
  }

  if (nextPeriod) {
    // Use silent selection to avoid animations
    selectPeriodSilently(nextPeriod);
  }
}

// Helper function to auto-select period based on flavor count (handles both upgrade and downgrade)
function autoSelectPeriodBasedOnFlavors(flavorCount) {
  // Calculate effective pack size for couple's pack
  let effectivePackSize = selectedPackSize;
  if (selectedDevice === "מארז זוגי" && selectedPackSize > 0) {
    effectivePackSize = selectedPackSize * 2; // Double the flavors for couple's pack
  }

  // If period was manually selected, only upgrade (never downgrade)
  if (periodManuallySelected && selectedPeriod) {
    // Check if current effective pack size can accommodate the flavor count
    if (flavorCount <= effectivePackSize) {
      // Current period can handle the flavors, no upgrade needed
      return;
    }

    // Need to upgrade - calculate what period is needed
    let targetPeriod = null;

    // Calculate required period based on device type
    let requiredPeriod = flavorCount;
    if (selectedDevice === "מארז זוגי") {
      // For couple's pack, divide by 2 to get the required period
      requiredPeriod = Math.ceil(flavorCount / 2);
    }

    // Check if we need unlimited mode
    if (selectedDevice === "מארז זוגי" && flavorCount > 24) {
      // More than 24 flavors for couple's pack - enable unlimited mode
      targetPeriod = 999;
    } else if (selectedDevice !== "מארז זוגי" && flavorCount > 12) {
      // More than 12 flavors for regular pack - enable unlimited mode
      targetPeriod = 999;
    } else if (requiredPeriod > 12) {
      // Need more than 12 months
      targetPeriod = 12;
    } else if (requiredPeriod > 6 && selectedPackSize < 12) {
      // Need 12 months
      targetPeriod = 12;
    } else if (requiredPeriod > 3 && selectedPackSize < 6) {
      // Need 6 months
      targetPeriod = 6;
    } else {
      // No upgrade needed, keep current period
      return;
    }

    if (targetPeriod === 999) {
      window.enableUnlimitedFlavors();
    } else if (targetPeriod > selectedPackSize) {
      selectPeriodSilently(targetPeriod);
    }
    return;
  }

  // If period wasn't manually selected, auto-select based on flavor count
  // Account for couple's pack when determining target period
  let targetPeriod = null;
  let requiredPeriod = flavorCount;

  // For couple's pack, divide by 2 to get the required period
  if (selectedDevice === "מארז זוגי") {
    requiredPeriod = Math.ceil(flavorCount / 2);
    // Minimum period is still 3 months
    if (requiredPeriod < 3) {
      requiredPeriod = 3;
    }
  }

  if (requiredPeriod <= 3) {
    targetPeriod = 3;
  } else if (requiredPeriod <= 6) {
    targetPeriod = 6;
  } else if (requiredPeriod <= 12) {
    targetPeriod = 12;
  } else {
    // More than 12 months needed - enable unlimited mode
    targetPeriod = 999;
  }

  // Auto-select if no period is selected
  if (!selectedPeriod) {
    if (targetPeriod === 999) {
      window.enableUnlimitedFlavors();
    } else {
      selectPeriodSilently(targetPeriod);
    }
  } else {
    // Period is already selected
    // If period was manually selected, check effective pack size first
    if (periodManuallySelected) {
      // Check if current effective pack size can accommodate the flavors
      if (flavorCount <= effectivePackSize && selectedPackSize < 999) {
        // Current period can handle the flavors, no change needed
        return;
      }
      // If flavors exceed effective pack size, the manual selection path above should handle it
      // But as a safeguard, don't auto-change manually selected periods
      return;
    }

    // Period wasn't manually selected - allow both upgrade and downgrade based on flavor count
    // Check if we need to change the period to match the flavor count
    if (targetPeriod === 999 && selectedPackSize < 999) {
      // Need unlimited mode
      window.enableUnlimitedFlavors();
    } else if (targetPeriod !== selectedPackSize) {
      // Period needs to change (could be upgrade or downgrade)
      if (targetPeriod < selectedPackSize) {
        // Downgrade: flavors reduced, so period should be reduced too
        selectPeriodSilently(targetPeriod);
      } else if (targetPeriod > selectedPackSize) {
        // Upgrade: flavors increased, so period should be increased
        selectPeriodSilently(targetPeriod);
      }
    }
    // If targetPeriod === selectedPackSize, no change needed
  }
}

// Make functions globally accessible
window.upgradeToNextPeriod = function () {
  autoUpgradePeriod();
};

window.enableUnlimitedFlavors = function () {
  // Set a very high limit to effectively allow unlimited flavors
  selectedPackSize = 999;

  // Update the summary to reflect unlimited mode
  updateSummary();

  // Hide the error message
  const err = document.querySelector(".luuf-error");
  err.style.display = "none";

  // Also hide mobile prompt warning
  const promptWarning = document.querySelector(".luuf-prompt-warning");
  if (promptWarning) {
    promptWarning.style.display = "none";
  }
};

window.scrollToPeriodSelection = function () {
  const periodSection = document.querySelector("#luuf-step1");
  if (periodSection) {
    periodSection.scrollIntoView({ behavior: "smooth", block: "center" });

    // Wait for scroll to complete before animating
    setTimeout(() => {
      // Add glance effect to period cards
      const periodCards = document.querySelectorAll("#luuf-step1 .luuf-device");
      periodCards.forEach((card, index) => {
        setTimeout(() => {
          card.style.animation = "glanceEffect 0.8s ease-out";
          setTimeout(() => {
            card.style.animation = "";
          }, 800);
        }, index * 100);
      });
    }, 300);
  }
};

window.scrollToDeviceSelection = function () {
  const deviceSection = document.querySelector("#luuf-step2");
  if (deviceSection) {
    deviceSection.scrollIntoView({ behavior: "smooth", block: "center" });

    // Wait for scroll to complete before animating
    setTimeout(() => {
      // Add glance effect to device cards
      const deviceCards = document.querySelectorAll("#luuf-step2 .luuf-device");
      deviceCards.forEach((card, index) => {
        setTimeout(() => {
          card.style.animation = "glanceEffect 0.8s ease-out";
          setTimeout(() => {
            card.style.animation = "";
          }, 800);
        }, index * 100);
      });
    }, 300);
  }
};

/* ---------- CONFIG ---------- */
const PACK_TARGET_DEFAULT = 3;
const MOBILE_BREAKPOINT = 600;
const SCROLL_THRESHOLD = 300;

// Feature flag to enable unlimited flavor selection after 3 flavors
// Set to false to restore the old mechanic (3/6/12+ pack limits)
const UNLIMITED_FLAVORS_AFTER_3 = true;

// Pack size configurations with discount info
const PACK_CONFIGS = {
  3: { discount: 0, discountText: "", originalPrice: 105, discountedPrice: 105 },
  6: { discount: 10, discountText: "10% הנחה", originalPrice: 210, discountedPrice: 189 },
  12: { discount: 20, discountText: "20% הנחה!", originalPrice: 420, discountedPrice: 336 },
};

// Device variant IDs - must stay in sync with the variants of משאף הגמילה - LUUF™ (/products/luuf)
const DEVICE_VARIANT_IDS = {
  שחור: "52574043046048",
  כסוף: "52574043078816",
  "מארז זוגי": "52575889916064",
};

// Gift variant IDs based on period
const GIFT_VARIANT_IDS = {
  3: "53136204136608", // 3 months - +1 gift
  6: "53136204300448", // 6 months - +2 gifts
  12: "53136204529824", // 12 months - +8 gifts
};

/* ---------- STATE ---------- */
let selectedPackSize = 0; // Start with 0 until period is selected
let flavorsSectionOpened = false;
let manualPackSelection = false;
let selectedDevice = null;
let selectedPeriod = null;
let justManuallySelected = false;
let flavorsGenerated = false; // Track if flavors have been generated
let periodManuallySelected = false; // Track if period was manually selected by user

// State persistence for flavor selections
let flavorSelections = {};

// Load saved state from localStorage
function loadSavedState() {
  try {
    const saved = localStorage.getItem("luuf_variant_picker_state");
    if (saved) {
      const state = JSON.parse(saved);
      selectedPackSize = state.selectedPackSize || 0;
      selectedDevice = state.selectedDevice || null;
      selectedPeriod = state.selectedPeriod || null;
      flavorSelections = state.flavorSelections || {};
      manualPackSelection = state.manualPackSelection || false;
    }
  } catch (e) {
    console.log("Could not load saved state:", e);
  }
}

// Save current state to localStorage
function saveState() {
  try {
    const state = {
      selectedPackSize,
      selectedDevice,
      selectedPeriod,
      flavorSelections,
      manualPackSelection,
    };
    // localStorage.setItem('luuf_variant_picker_state', JSON.stringify(state));
  } catch (e) {
    console.log("Could not save state:", e);
  }
}

// Clear saved state
function clearState() {
  try {
    localStorage.removeItem("luuf_variant_picker_state");
    selectedPackSize = 0;
    selectedDevice = null;
    selectedPeriod = null;
    flavorSelections = {};
    manualPackSelection = false;
  } catch (e) {
    console.log("Could not clear state:", e);
  }
}

/* ---------- BUILD FLAVOR GRID ---------- */
function generateFlavorsFromData(forceRegenerate = false) {
  console.time("generateFlavors");
  const grid = document.getElementById("flavors-grid");
  if (!Array.isArray(validFlavorsData)) return;

  // Skip if already generated unless forced
  if (flavorsGenerated && !forceRegenerate) {
    console.log("Skipping flavor generation - already generated");
    return;
  }

  // Generate immediately since sections are always open
  grid.innerHTML = validFlavorsData
    .map((f, index) => {
      const savedQty = flavorSelections[f.id] || 0;
      const isFirstThree = index < 3;
      const badgeHtml = isFirstThree
        ? `
          <div style="position: absolute; top: -6px; right: -11%; background: linear-gradient(135deg, #4CAF50, #45a049); color: white; padding: 4px 8px; border-radius: 12px; font-weight: 700; font-size: 11px; box-shadow: 0 2px 8px rgba(0,0,0,0.2); transform: rotate(15deg); z-index: 10;">
            הכי נמכר!
          </div>
        `
        : "";

      if (savedQty > 0) {
        return `
  						<div class="luuf-flavour" data-label="${f.title}" data-variant-id="${f.id}" style="position: relative;">
  							${badgeHtml}
  							<img style="object-fit:cover;border-radius:10px;cursor:pointer;" src="${f.image}" alt="${f.title}" loading="eager" />
  							<p class="luuf-name">${f.title}</p>
  							<div class="luuf-qty">
  								<button type="button" class="luuf-minus">−</button>
  								<span class="luuf-count">${savedQty}</span>
  								<button type="button" class="luuf-plus">+</button>
  							</div>
  						</div>
  					`;
      } else {
        return `
  						<div class="luuf-flavour" data-label="${f.title}" data-variant-id="${f.id}" style="position: relative;">
  							${badgeHtml}
  							<img style="object-fit:cover;border-radius:10px;cursor:pointer;" src="${f.image}" alt="${f.title}" loading="eager" />
  							<p class="luuf-name">${f.title}</p>
  							<div class="luuf-select"><button class="luuf-add">בחירה</button></div>
  						</div>
  					`;
      }
    })
    .join("");

  flavorsGenerated = true;
}

/* ---------- ACCORDION ---------- */
function initAccordion() {
  $all(".luuf-toggle").forEach((btn) =>
    btn.addEventListener("click", (e) => {
      const tgt = document.querySelector(btn.dataset.target);
      const open = btn.getAttribute("aria-expanded") === "true";

      // Prevent any dropdowns from being closed - they should always stay open
      if (open) {
        return;
      }

      if (!open && btn.dataset.target === "#luuf-step2") {
        // Check if a period has been selected before allowing device section to open
        const selectedPeriodCard = document.querySelector("#luuf-step1 .luuf-device.selected");
        if (!selectedPeriodCard) {
          return; // Don't open device section if no period is selected
        }
      }

      if (!open && btn.dataset.target === "#luuf-step3") {
        // Check if a device has been selected before allowing flavors section to open
        const selectedDeviceCard = document.querySelector("#luuf-step2 .luuf-device.selected");
        if (!selectedDeviceCard) {
          return; // Don't open flavors section if no device is selected
        }

        flavorsSectionOpened = true;
        generateFlavorsFromData();

        // Trigger mobile bar update to show add to cart if user is scrolled down enough
        setTimeout(triggerMobileBarUpdate, 100);
      }

      // Only open sections, never close them
      if (!open) {
        btn.setAttribute("aria-expanded", "true");
        if (btn.dataset.target === "#luuf-step1") {
          tgt.style.padding = "0 0 0";
          tgt.style.maxHeight = "none";
        } else if (btn.dataset.target === "#luuf-step2") {
          tgt.style.padding = "0 0 0";
          tgt.style.maxHeight = "none";
        } else if (btn.dataset.target === "#luuf-step3") {
          tgt.style.padding = "0 0 8px";
          tgt.style.maxHeight = "none";
        }
      }
    }),
  );
}

/* ---------- PERIOD SELECT ---------- */
function initPeriodSelect() {
  // Use the same selector as device selection but only for step 1
  const periodCards = document.querySelectorAll("#luuf-step1 .luuf-device");
  periodCards.forEach((card) => {
    card.addEventListener("click", () => {
      periodCards.forEach((c) => {
        c.classList.remove("selected");
        const b = c.querySelector("button");
        b.textContent = b.textContent.replace("נבחר", "בחירה");
      });

      card.classList.add("selected");
      const btn = card.querySelector("button");
      btn.textContent = btn.textContent.replace("בחירה", "נבחר");
      const title = card.querySelector("h4").textContent;
      selectedPeriod = title;
      selectedPackSize = parseInt(title.split(" ")[0]); // Extract number from "3 חודשים", "6 חודשים", etc.

      // Mark that period was manually selected
      periodManuallySelected = true;

      // Clear existing flavor selections when period changes
      const currentTotal = getTotalFlavors();
      if (currentTotal > selectedPackSize) {
        // Remove excess flavors if new period is smaller
        const flavorCards = document.querySelectorAll(".luuf-flavour");
        let remainingSlots = selectedPackSize;

        flavorCards.forEach((card) => {
          const qtySpan = card.querySelector(".luuf-count");
          if (qtySpan && remainingSlots > 0) {
            const currentQty = +qtySpan.textContent;
            const variantId = card.dataset.variantId;

            if (currentQty > remainingSlots) {
              // Reduce quantity to fit remaining slots
              qtySpan.textContent = remainingSlots;
              flavorSelections[variantId] = remainingSlots;
              remainingSlots = 0;
            } else {
              // Keep this flavor as is
              remainingSlots -= currentQty;
            }
          } else if (qtySpan && remainingSlots <= 0) {
            // Remove this flavor completely
            convertToSelectMode(card);
            const variantId = card.dataset.variantId;
            delete flavorSelections[variantId];
          }
        });
      }

      const step1 = document.querySelector('[data-target="#luuf-step1"]');
      const step1Text = step1.querySelector(".step-text");
      if (step1Text) {
        step1Text.textContent = `1. בחירת תקופת גמילה - ${title}`;
      }
      step1.classList.add("completed");
      updateTickContent(step1, true);

      // Save state
      saveState();

      // Update summary to show flavor selection message
      updateSummary();

      // Show flavor count again when period is selected
      const summaryCount = document.querySelector(".luuf-summary-count");
      if (summaryCount) {
        summaryCount.style.display = "block";
      }

      // Update type selection prompt
      updateTypeSelectionPrompt();

      // Clear error if both period and device are now selected
      if (selectedPeriod && selectedDevice) {
        const err = document.querySelector(".luuf-error");
        const promptWarning = document.querySelector(".luuf-prompt-warning");
        if (err) {
          err.style.display = "none";
        }
        if (promptWarning) {
          promptWarning.style.display = "none";
        }
      }

      setTimeout(() => {
        // Keep the period selection dropdown open - don't close it
        const pToggle = step1;
        const pPanel = document.querySelector("#luuf-step1");
        pToggle.setAttribute("aria-expanded", "true");
        pPanel.style.maxHeight = "none";
        pPanel.style.padding = "0 0 0";

        // Check if device is already selected
        const selectedDeviceCard = document.querySelector("#luuf-step2 .luuf-device.selected");

        if (selectedDeviceCard) {
          // Device already selected, go directly to flavors
          const fToggle = document.querySelector('[data-target="#luuf-step3"]');
          if (fToggle.getAttribute("aria-expanded") === "false") fToggle.click();

          // Scroll to center the flavors selector with animation
          setTimeout(() => {
            const flavorsSection = document.querySelector("#luuf-step3");
            if (flavorsSection) {
              const sectionHeight = flavorsSection.offsetHeight;
              const windowHeight = window.innerHeight;
              const targetScrollTop = flavorsSection.offsetTop - windowHeight / 2 + sectionHeight / 2;

              window.scrollTo({
                top: targetScrollTop,
                behavior: "smooth",
              });

              // Add glance effect to each flavor after scroll completes
              let scrollCheckInterval;
              const checkScrollComplete = () => {
                if (Math.abs(window.pageYOffset - targetScrollTop) < 5) {
                  clearInterval(scrollCheckInterval);

                  // Add glance effect to each flavor card
                  const flavorCards = document.querySelectorAll(".luuf-flavour");
                  flavorCards.forEach((card, index) => {
                    setTimeout(() => {
                      card.style.animation = "glanceEffect 0.8s ease-out";
                      setTimeout(() => {
                        card.style.animation = "";
                      }, 800);
                    }, index * 100); // Stagger the animations
                  });
                }
              };

              // Check every 50ms if scroll has completed
              scrollCheckInterval = setInterval(checkScrollComplete, 50);
            }
          }, 100);
        } else {
          // No device selected, go to device selection
          const dToggle = document.querySelector('[data-target="#luuf-step2"]');
          if (dToggle.getAttribute("aria-expanded") === "false") dToggle.click();

          // Scroll to center the device selector with animation
          setTimeout(() => {
            const deviceSection = document.querySelector("#luuf-step2");
            if (deviceSection) {
              const sectionHeight = deviceSection.offsetHeight;
              const windowHeight = window.innerHeight;
              const targetScrollTop = deviceSection.offsetTop - windowHeight / 2 + sectionHeight / 2;

              window.scrollTo({
                top: targetScrollTop,
                behavior: "smooth",
              });

              // Add glance effect after scroll completes
              let scrollCheckInterval;
              const checkScrollComplete = () => {
                if (Math.abs(window.pageYOffset - targetScrollTop) < 5) {
                  clearInterval(scrollCheckInterval);

                  // Add a subtle shiny wave animation to draw attention
                  deviceSection.style.animation = "glanceEffect 0.8s ease-out";

                  // Remove the animation after it completes
                  setTimeout(() => {
                    deviceSection.style.animation = "";
                  }, 800);
                }
              };

              // Check every 50ms if scroll has completed
              scrollCheckInterval = setInterval(checkScrollComplete, 50);
            }
          }, 100);
        }

        // Trigger mobile bar update to show add to cart if user is scrolled down enough
        setTimeout(triggerMobileBarUpdate, 100);
      }, 250);
    });
  });
}

/* ---------- DEVICE SELECT ---------- */
function initDeviceSelect() {
  // Only target devices in step 2
  const deviceCards = document.querySelectorAll("#luuf-step2 .luuf-device");
  deviceCards.forEach((card) => {
    card.addEventListener("click", () => {
      deviceCards.forEach((c) => {
        c.classList.remove("selected");
        const b = c.querySelector("button");
        b.textContent = b.textContent.replace("נבחר", "בחירה");
      });

      card.classList.add("selected");
      const btn = card.querySelector("button");
      btn.textContent = btn.textContent.replace("בחירה", "נבחר");
      const title = card.querySelector("h4").textContent;
      selectedDevice = title;
      const step2 = document.querySelector('[data-target="#luuf-step2"]');
      const step2Text = step2.querySelector(".step-text");
      if (step2Text) {
        step2Text.textContent = `2. בחירת סוג - ${title}`;
      }
      step2.classList.add("completed");
      updateTickContent(step2, true);

      // Save state
      saveState();

      // Update summary to show flavor selection message
      updateSummary();

      // Show flavor count again when device is selected
      const summaryCount = document.querySelector(".luuf-summary-count");
      if (summaryCount) {
        summaryCount.style.display = "block";
      }

      // Update type selection prompt
      updateTypeSelectionPrompt();

      // Clear error if both period and device are now selected
      if (selectedPeriod && selectedDevice) {
        const err = document.querySelector(".luuf-error");
        const promptWarning = document.querySelector(".luuf-prompt-warning");
        if (err) {
          err.style.display = "none";
        }
        if (promptWarning) {
          promptWarning.style.display = "none";
        }
      }

      setTimeout(() => {
        // Keep the device selection dropdown open - don't close it
        const dToggle = step2;
        const dPanel = document.querySelector("#luuf-step2");
        dToggle.setAttribute("aria-expanded", "true");
        dPanel.style.maxHeight = "none";
        dPanel.style.padding = "0 0 0";

        // Check if period is already selected
        const selectedPeriodCard = document.querySelector("#luuf-step1 .luuf-device.selected");

        if (selectedPeriodCard) {
          // Period already selected, go directly to flavors
          const fToggle = document.querySelector('[data-target="#luuf-step3"]');
          if (fToggle.getAttribute("aria-expanded") === "false") fToggle.click();

          // Scroll to center the flavors selector with animation
          setTimeout(() => {
            const flavorsSection = document.querySelector("#luuf-step3");
            if (flavorsSection) {
              const sectionHeight = flavorsSection.offsetHeight;
              const windowHeight = window.innerHeight;
              const targetScrollTop = flavorsSection.offsetTop - windowHeight / 2 + sectionHeight / 2;

              window.scrollTo({
                top: targetScrollTop,
                behavior: "smooth",
              });

              // Add glance effect to each flavor after scroll completes
              let scrollCheckInterval;
              const checkScrollComplete = () => {
                if (Math.abs(window.pageYOffset - targetScrollTop) < 5) {
                  clearInterval(scrollCheckInterval);

                  // Add glance effect to each flavor card
                  const flavorCards = document.querySelectorAll(".luuf-flavour");
                  flavorCards.forEach((card, index) => {
                    setTimeout(() => {
                      card.style.animation = "glanceEffect 0.8s ease-out";
                      setTimeout(() => {
                        card.style.animation = "";
                      }, 800);
                    }, index * 100); // Stagger the animations
                  });
                }
              };

              // Check every 50ms if scroll has completed
              scrollCheckInterval = setInterval(checkScrollComplete, 50);
            }
          }, 100);
        } else {
          // No period selected, go to period selection
          const pToggle = document.querySelector('[data-target="#luuf-step1"]');
          if (pToggle.getAttribute("aria-expanded") === "false") pToggle.click();

          // Scroll to center the period selector with animation
          setTimeout(() => {
            const periodSection = document.querySelector("#luuf-step1");
            if (periodSection) {
              const sectionHeight = periodSection.offsetHeight;
              const windowHeight = window.innerHeight;
              const targetScrollTop = periodSection.offsetTop - windowHeight / 2 + sectionHeight / 2;

              window.scrollTo({
                top: targetScrollTop,
                behavior: "smooth",
              });

              // Add glance effect after scroll completes
              let scrollCheckInterval;
              const checkScrollComplete = () => {
                if (Math.abs(window.pageYOffset - targetScrollTop) < 5) {
                  clearInterval(scrollCheckInterval);

                  // Add a subtle shiny wave animation to draw attention
                  periodSection.style.animation = "glanceEffect 0.8s ease-out";

                  // Remove the animation after it completes
                  setTimeout(() => {
                    periodSection.style.animation = "";
                  }, 800);
                }
              };

              // Check every 50ms if scroll has completed
              scrollCheckInterval = setInterval(checkScrollComplete, 50);
            }
          }, 100);
        }

        // Trigger mobile bar update to show add to cart if user is scrolled down enough
        setTimeout(triggerMobileBarUpdate, 100);
      }, 250);
    });
  });
}

/* ---------- FLAVOR SELECT & QTY (delegated) ---------- */
function convertToQtyMode(card) {
  const img = card.querySelector("img").outerHTML;
  const lbl = card.dataset.label;

  // Check if this is one of the first 3 flavors
  const allFlavorCards = document.querySelectorAll(".luuf-flavour");
  const cardIndex = Array.from(allFlavorCards).indexOf(card);
  const isFirstThree = cardIndex < 3;
  const badgeHtml = isFirstThree
    ? `
    <div style="position: absolute; top: -6px; right: -11%; background: linear-gradient(135deg, #4CAF50, #45a049); color: white; padding: 4px 8px; border-radius: 12px; font-weight: 700; font-size: 11px; box-shadow: 0 2px 8px rgba(0,0,0,0.2); transform: rotate(15deg); z-index: 10;">
      הכי נמכר!
    </div>
  `
    : "";

  card.innerHTML = `
	       ${badgeHtml}
	       ${img}
	       <p class="luuf-name">${lbl}</p>
	       <div class="luuf-qty">
	         <button type="button" class="luuf-minus">−</button>
	         <span class="luuf-count">1</span>
	         <button type="button" class="luuf-plus">+</button>
	       </div>
	     `;
}

function convertToSelectMode(card) {
  const img = card.querySelector("img").outerHTML;
  const lbl = card.dataset.label;

  // Check if this is one of the first 3 flavors
  const allFlavorCards = document.querySelectorAll(".luuf-flavour");
  const cardIndex = Array.from(allFlavorCards).indexOf(card);
  const isFirstThree = cardIndex < 3;
  const badgeHtml = isFirstThree
    ? `
    <div style="position: absolute; top: -6px; right: -11%; background: linear-gradient(135deg, #4CAF50, #45a049); color: white; padding: 4px 8px; border-radius: 12px; font-weight: 700; font-size: 11px; box-shadow: 0 2px 8px rgba(0,0,0,0.2); transform: rotate(15deg); z-index: 10;">
      הכי נמכר!
    </div>
  `
    : "";

  card.innerHTML = `
	       ${badgeHtml}
	       ${img}
	       <p class="luuf-name">${lbl}</p>
	       <div class="luuf-select"><button class="luuf-add">בחירה</button></div>
	     `;
}

function initFlavorDelegation() {
  document.getElementById("flavors-grid").addEventListener("click", (e) => {
    const card = e.target.closest(".luuf-flavour");
    if (!card) return;

    /* click on ADD button */
    if (e.target.classList.contains("luuf-add")) {
      // Check if period is selected first - block selection if not selected
      if (!selectedPeriod || selectedPackSize === 0) {
        showError("נא לבחור תקופת גמילה לפני בחירת טעמים", "לחץ כאן לבחירת תקופה", "scrollToPeriodSelection()");
        return; // Block the selection
      } else if (!selectedDevice) {
        showError("נא לבחור סוג לפני בחירת טעמים", "לחץ כאן לבחירת סוג", "scrollToDeviceSelection()");
        return; // Block the selection
      }

      // Clear any existing error messages since both period and device are selected
      const err = document.querySelector(".luuf-error");
      const promptWarning = document.querySelector(".luuf-prompt-warning");
      if (err) {
        err.style.display = "none";
      }
      if (promptWarning) {
        promptWarning.style.display = "none";
      }

      // Check if we can add more flavors based on selected period
      const currentTotal = getTotalFlavors();
      let effectivePackSize = selectedPackSize;
      if (selectedDevice === "מארז זוגי") {
        effectivePackSize = selectedPackSize * 2; // Double the flavors for couple's pack
      }

      // Only check flavor limits if period and device are actually selected
      // For couple's pack + 12 months, allow exactly 24 flavors (effectivePackSize = 24)
      // Only enable unlimited when trying to exceed 24 (currentTotal > 24, not >=)
      const isAtLimit =
        selectedDevice === "מארז זוגי" && selectedPackSize === 12
          ? currentTotal > 24 // For couple's pack + 12 months, allow exactly 24
          : currentTotal >= effectivePackSize; // For all other cases, use >=

      if (selectedPeriod && selectedDevice && isAtLimit && effectivePackSize < 999) {
        // Automatically upgrade to next period instead of showing error
        // For couple's pack + 12 months, allow up to 24 flavors before enabling unlimited
        if (selectedPackSize === 12) {
          if (selectedDevice === "מארז זוגי") {
            // Couple's pack + 12 months = 24 flavors capacity, enable unlimited when trying to exceed 24
            window.enableUnlimitedFlavors();
          } else {
            // Regular pack + 12 months, enable unlimited mode
            window.enableUnlimitedFlavors();
          }
        } else {
          // Automatically upgrade to next period (3->6 or 6->12)
          autoUpgradePeriod();
        }
        // Continue with the selection after upgrade
      }

      convertToQtyMode(card);
      // Save the selection
      const variantId = card.dataset.variantId;
      flavorSelections[variantId] = 1;
      saveState();

      // Auto-adjust period based on flavor count
      const newTotal = getTotalFlavors();
      if (newTotal > 0) {
        autoSelectPeriodBasedOnFlavors(newTotal);
      }

      updateSummary();
      updateTypeSelectionPrompt();
      // Trigger mobile bar update to show error if needed
      setTimeout(triggerMobileBarUpdate, 100);
      return;
    }

    /* click on image */
    if (e.target.tagName === "IMG") {
      // Check if period is selected first - block selection if not selected
      if (!selectedPeriod || selectedPackSize === 0) {
        showError("נא לבחור תקופת גמילה לפני בחירת טעמים", "לחץ כאן לבחירת תקופה", "scrollToPeriodSelection()");
        return; // Block the selection
      } else if (!selectedDevice) {
        showError("נא לבחור סוג לפני בחירת טעמים", "לחץ כאן לבחירת סוג", "scrollToDeviceSelection()");
        return; // Block the selection
      }

      // Clear any existing error messages since both period and device are selected
      const err = document.querySelector(".luuf-error");
      const promptWarning = document.querySelector(".luuf-prompt-warning");
      if (err) {
        err.style.display = "none";
      }
      if (promptWarning) {
        promptWarning.style.display = "none";
      }

      const qtySpan = card.querySelector(".luuf-count");
      if (qtySpan) {
        const newQty = +qtySpan.textContent + 1;
        // Check if we can add more flavors based on selected period
        const currentTotal = getTotalFlavors();
        let effectivePackSize = selectedPackSize;
        if (selectedDevice === "מארז זוגי") {
          effectivePackSize = selectedPackSize * 2; // Double the flavors for couple's pack
        }

        // Only check flavor limits if period and device are actually selected
        // For couple's pack + 12 months, allow exactly 24 flavors (effectivePackSize = 24)
        // Only enable unlimited when trying to exceed 24 (currentTotal > 24, not >=)
        const isAtLimit =
          selectedDevice === "מארז זוגי" && selectedPackSize === 12
            ? currentTotal > 24 // For couple's pack + 12 months, allow exactly 24
            : currentTotal >= effectivePackSize; // For all other cases, use >=

        if (selectedPeriod && selectedDevice && isAtLimit && effectivePackSize < 999) {
          // Automatically upgrade to next period instead of showing error
          // For couple's pack + 12 months, allow up to 24 flavors before enabling unlimited
          if (selectedPackSize === 12) {
            if (selectedDevice === "מארז זוגי") {
              // Couple's pack + 12 months = 24 flavors capacity, enable unlimited when trying to exceed 24
              window.enableUnlimitedFlavors();
            } else {
              // Regular pack + 12 months, enable unlimited mode
              window.enableUnlimitedFlavors();
            }
          } else {
            // Automatically upgrade to next period (3->6 or 6->12)
            autoUpgradePeriod();
          }
          // Continue with the selection after upgrade
        }
        qtySpan.textContent = newQty;
        // Save the selection
        const variantId = card.dataset.variantId;
        flavorSelections[variantId] = newQty;
        saveState();

        // Auto-adjust period based on flavor count
        const newTotal = getTotalFlavors();
        if (newTotal > 0) {
          autoSelectPeriodBasedOnFlavors(newTotal);
        }
      } else {
        // Check if we can add more flavors based on selected period
        const currentTotal = getTotalFlavors();
        let effectivePackSize = selectedPackSize;
        if (selectedDevice === "מארז זוגי") {
          effectivePackSize = selectedPackSize * 2; // Double the flavors for couple's pack
        }

        // Only check flavor limits if period and device are actually selected
        // For couple's pack + 12 months, allow exactly 24 flavors (effectivePackSize = 24)
        // Only enable unlimited when trying to exceed 24 (currentTotal > 24, not >=)
        const isAtLimit =
          selectedDevice === "מארז זוגי" && selectedPackSize === 12
            ? currentTotal > 24 // For couple's pack + 12 months, allow exactly 24
            : currentTotal >= effectivePackSize; // For all other cases, use >=

        if (selectedPeriod && selectedDevice && isAtLimit && effectivePackSize < 999) {
          // Automatically upgrade to next period instead of showing error
          // For couple's pack + 12 months, allow up to 24 flavors before enabling unlimited
          if (selectedPackSize === 12) {
            if (selectedDevice === "מארז זוגי") {
              // Couple's pack + 12 months = 24 flavors capacity, enable unlimited when trying to exceed 24
              window.enableUnlimitedFlavors();
            } else {
              // Regular pack + 12 months, enable unlimited mode
              window.enableUnlimitedFlavors();
            }
          } else {
            // Automatically upgrade to next period (3->6 or 6->12)
            autoUpgradePeriod();
          }
          // Continue with the selection after upgrade
        }
        convertToQtyMode(card);
        // Save the selection
        const variantId = card.dataset.variantId;
        flavorSelections[variantId] = 1;
        saveState();

        // Auto-adjust period based on flavor count
        const newTotal = getTotalFlavors();
        if (newTotal > 0) {
          autoSelectPeriodBasedOnFlavors(newTotal);
        }
      }
      updateSummary();
      updateTypeSelectionPrompt();
      // Trigger mobile bar update to show error if needed
      setTimeout(triggerMobileBarUpdate, 100);
      return;
    }

    /* click on + / − */
    if (e.target.classList.contains("luuf-plus") || e.target.classList.contains("luuf-minus")) {
      const qtySpan = card.querySelector(".luuf-count");
      let q = +qtySpan.textContent + (e.target.classList.contains("luuf-plus") ? 1 : -1);
      q = Math.max(q, 0);
      const variantId = card.dataset.variantId;

      // Check if we can add more flavors based on selected period (only for plus button)
      if (e.target.classList.contains("luuf-plus")) {
        // Check if period is selected first - block selection if not selected
        if (!selectedPeriod || selectedPackSize === 0) {
          showError("נא לבחור תקופת גמילה לפני בחירת טעמים", "לחץ כאן לבחירת תקופה", "scrollToPeriodSelection()");
          return; // Block the selection
        } else if (!selectedDevice) {
          showError("נא לבחור סוג לפני בחירת טעמים", "לחץ כאן לבחירת סוג", "scrollToDeviceSelection()");
          return; // Block the selection
        }

        // Clear any existing error messages since both period and device are selected
        const err = document.querySelector(".luuf-error");
        const promptWarning = document.querySelector(".luuf-prompt-warning");
        if (err) {
          err.style.display = "none";
        }
        if (promptWarning) {
          promptWarning.style.display = "none";
        }

        const currentTotal = getTotalFlavors();
        let effectivePackSize = selectedPackSize;
        if (selectedDevice === "מארז זוגי") {
          effectivePackSize = selectedPackSize * 2; // Double the flavors for couple's pack
        }

        // Only check flavor limits if period and device are actually selected
        // For couple's pack + 12 months, allow exactly 24 flavors (effectivePackSize = 24)
        // Only enable unlimited when trying to exceed 24 (currentTotal > 24, not >=)
        const isAtLimit =
          selectedDevice === "מארז זוגי" && selectedPackSize === 12
            ? currentTotal > 24 // For couple's pack + 12 months, allow exactly 24
            : currentTotal >= effectivePackSize; // For all other cases, use >=

        if (selectedPeriod && selectedDevice && isAtLimit && effectivePackSize < 999) {
          // Automatically upgrade to next period instead of showing error
          // For couple's pack + 12 months, allow up to 24 flavors before enabling unlimited
          if (selectedPackSize === 12) {
            if (selectedDevice === "מארז זוגי") {
              // Couple's pack + 12 months = 24 flavors capacity, enable unlimited when trying to exceed 24
              window.enableUnlimitedFlavors();
            } else {
              // Regular pack + 12 months, enable unlimited mode
              window.enableUnlimitedFlavors();
            }
          } else {
            // Automatically upgrade to next period (3->6 or 6->12)
            autoUpgradePeriod();
          }
          // Continue with the selection after upgrade
        }
      }

      if (q === 0) {
        convertToSelectMode(card);
        // Remove from selections
        delete flavorSelections[variantId];
      } else {
        qtySpan.textContent = q;
        // Save the selection
        flavorSelections[variantId] = q;
      }

      // Auto-adjust period based on flavor count (handles both add and remove)
      const newTotal = getTotalFlavors();
      if (newTotal > 0) {
        autoSelectPeriodBasedOnFlavors(newTotal);
      } else if (newTotal === 0 && selectedPeriod) {
        // If all flavors removed, keep the period selected (don't clear it)
      }

      saveState();
      updateSummary();
      updateTypeSelectionPrompt();
      // Trigger mobile bar update to show error if needed
      setTimeout(triggerMobileBarUpdate, 100);
    }
  });
}

/* ---------- PACK SELECT (REMOVED - NOW USING PERIOD-BASED SELECTION) ---------- */

/* ---------- SUMMARY ---------- */
const getTotalFlavors = () => $all(".luuf-count").reduce((t, s) => t + +s.textContent, 0);

// Calculate flavor price based on quantity (tiered pricing)
function calculateFlavorPrice(quantity) {
  if (quantity === 0) return 0;
  if (quantity >= 12) return quantity * 28; // 12+ flavors: ₪28 each
  if (quantity >= 6) return quantity * 31.5; // 6-11 flavors: ₪31.50 each
  return quantity * 35; // 1-5 flavors: ₪35 each
}

// Calculate device price
// The couple's pack carries an automatic 15% store discount ("מארז-זוגי"),
// so the amount actually charged is ₪312.80 rather than its ₪368 list price.
function calculateDevicePrice(device) {
  if (device === "מארז זוגי") return 312.8;
  if (device === "שחור" || device === "כסוף") return 184;
  return 0;
}

// Calculate compare at prices
function calculateCompareAtPrice(quantity, device) {
  const flavorCompare = quantity * 50; // ₪50 per flavor compare price
  const deviceCompare = device === "מארז זוגי" ? 598 : 299;
  return flavorCompare + deviceCompare;
}

/* ---------- MONTHLY SUBSCRIPTION UPSELL ---------- */
const SUBSCRIPTION_ORDER_DISCOUNT = 0.1;
const SUBSCRIPTION_DISCOUNT_CODE = "10offorder";

// The checkbox carries its variant/selling plan/prices as data attributes,
// rendered from the product in variant-picker.liquid.
function getSubscriptionToggle() {
  const toggle = document.getElementById("luuf-sub-toggle");
  return toggle && toggle.checked ? toggle : null;
}

function getSubscriptionVariantId() {
  const toggle = document.getElementById("luuf-sub-toggle");
  return toggle ? toggle.dataset.variantId : null;
}

// Shopify merges a repeat add of the same variant and selling plan into the existing
// line, so adding to cart twice would silently subscribe the customer twice. A
// quantity the customer set themselves in the cart is left untouched.
function findSubscriptionLine(cart, variantId) {
  if (!variantId) return null;
  const items = cart.items || [];
  return items.find((item) => String(item.variant_id) === String(variantId)) || null;
}

// List prices, before the store's automatic per-line discounts. Shopify bases the
// automatic 10% club discount on these rather than on the discounted subtotal.
function calculateListPrice(quantity, device) {
  let deviceList = 0;
  if (device === "מארז זוגי") deviceList = 368;
  else if (device === "שחור" || device === "כסוף") deviceList = 184;
  return quantity * 35 + deviceList;
}

// The first month of the subscription is free, so it adds nothing to this order.
// Opting in instead triggers the automatic 10% club discount ("הנחת מועדון").
function applySubscriptionDiscount(total, quantity, device) {
  if (!getSubscriptionToggle()) return total;
  return total - calculateListPrice(quantity, device) * SUBSCRIPTION_ORDER_DISCOUNT;
}

function suggestPack(n) {
  if (n <= 3) return 3;
  if (n <= 6) return 6;
  return 12;
}

function getNextPackSize(currentSize) {
  if (currentSize < 6) return 6;
  if (currentSize < 12) return 12;
  return null;
}

function getMissingForDiscount(currentCount, targetPackSize) {
  const nextPack = getNextPackSize(targetPackSize);
  console.log("getMissingForDiscount:", { currentCount, targetPackSize, nextPack });

  if (!nextPack) return null;

  const missing = nextPack - currentCount;
  const nextConfig = PACK_CONFIGS[nextPack];
  const result = {
    missing: missing,
    nextPack: nextPack,
    discountText: nextConfig.discountText,
  };
  console.log("Discount result:", result);
  return result;
}

function syncPackAuto(n) {
  // Since we're now using period-based selection, we don't auto-sync pack sizes
  // The selectedPackSize is determined by the selected period, not by flavor count
  return;
}

function updateSummary() {
  $all(".luuf-count").forEach((span) => {
    if (+span.textContent === 0) convertToSelectMode(span.closest(".luuf-flavour"));
  });

  const n = getTotalFlavors();

  // No auto-adjustment needed since we're using period-based selection
  // The selectedPackSize is determined by the selected period, not by flavor count

  syncPackAuto(n);
  const progressBar = document.querySelector(".luuf-progress-bar");
  if (progressBar && selectedPackSize > 0) {
    if (selectedPackSize >= 999) {
      // Unlimited mode - show full progress bar
      progressBar.style.width = "100%";
    } else {
      // Calculate effective pack size for progress bar
      let effectivePackSize = selectedPackSize;
      if (selectedDevice === "מארז זוגי") {
        effectivePackSize = selectedPackSize * 2; // Double the flavors for couple's pack
      }
      progressBar.style.width = `${Math.min(n / effectivePackSize, 1) * 100}%`;
    }
  } else if (progressBar) {
    progressBar.style.width = "0%";
  }

  const err = document.querySelector(".luuf-error");
  const cart = document.querySelector(".luuf-addcart");
  const price = document.querySelector(".luuf-summary-price");
  const orig = document.querySelector(".luuf-summary-original");
  const step2 = document.querySelector('[data-target="#luuf-step2"]');

  // Calculate effective pack size based on device selection
  let effectivePackSize = selectedPackSize;
  if (selectedDevice === "מארז זוגי") {
    effectivePackSize = selectedPackSize * 2; // Double the flavors for couple's pack
  }

  const remain = effectivePackSize ? Math.max(effectivePackSize - n, 0) : 0;

  // Check if period and device are selected first
  if (!selectedPeriod || !selectedDevice) {
    // Show appropriate warning
    const deviceWarning = document.querySelector(".luuf-device-warning");
    const summaryCount = document.querySelector(".luuf-summary-count");
    const promptWarning = document.querySelector(".luuf-prompt-warning");

    // Don't override if error already shows the correct message
    const currentErrorText = err.textContent;
    const isCorrectMessage =
      currentErrorText.includes("נא לבחור תקופת גמילה לפני בחירת טעמים") ||
      currentErrorText.includes("נא לבחור סוג לפני בחירת טעמים");

    if (n > 0) {
      if (!selectedPeriod) {
        if (!isCorrectMessage) {
          err.textContent = "נא לבחור תקופת גמילה לפני הוספה לעגלה";
        }
        if (promptWarning) {
          promptWarning.textContent = "נא לבחור תקופת גמילה לפני הוספה לעגלה";
          promptWarning.style.display = "block";
        }
      } else if (!selectedDevice) {
        deviceWarning.style.display = "block";
        err.style.display = "none";
        if (promptWarning) {
          promptWarning.textContent = "נא לבחור סוג לפני הוספה לעגלה";
          promptWarning.style.display = "block";
        }
      }
      // Hide flavor count when period or device not selected
      if (summaryCount) {
        summaryCount.style.display = "none";
      }
    } else {
      deviceWarning.style.display = "none";
      if (!selectedPeriod) {
        if (!isCorrectMessage) {
          err.textContent = "נא לבחור תקופת גמילה לפני הוספה לעגלה";
        }
        if (promptWarning) {
          promptWarning.textContent = "נא לבחור תקופת גמילה לפני הוספה לעגלה";
          promptWarning.style.display = "block";
        }
      } else if (!selectedDevice) {
        if (!isCorrectMessage) {
          err.textContent = "נא לבחור סוג לפני הוספה לעגלה";
        }
        if (promptWarning) {
          promptWarning.textContent = "נא לבחור סוג לפני הוספה לעגלה";
          promptWarning.style.display = "block";
        }
      }
      err.classList.remove("discount-upgrade");
      err.style.display = "block";
      // Show flavor count when no flavors and period/device not selected
      if (summaryCount) {
        summaryCount.style.display = "block";
      }
    }
    cart.disabled = true;
    price.textContent = orig.textContent = "₪ 0.00";
    return;
  }

  // Handle unlimited mode separately
  if (remain > 0 && selectedPackSize >= 999 && n > 0) {
    // Unlimited mode - calculate dynamic pricing
    const deviceWarning = document.querySelector(".luuf-device-warning");
    if (deviceWarning) {
      deviceWarning.style.display = "none";
    }

    // Hide error message in unlimited mode
    err.style.display = "none";
    err.classList.remove("discount-upgrade");

    // Hide mobile prompt completely in unlimited mode
    const promptWarning = document.querySelector(".luuf-prompt-warning");
    const typePrompt = document.querySelector(".luuf-type-selection-prompt");
    if (promptWarning) {
      promptWarning.style.display = "none";
    }
    if (typePrompt) {
      typePrompt.classList.remove("show");
    }

    // Cart should be enabled in unlimited mode
    cart.disabled = false;

    // Use simplified pricing
    const total = applySubscriptionDiscount(
      calculateFlavorPrice(n) + calculateDevicePrice(selectedDevice),
      n,
      selectedDevice
    );
    const compareAt = calculateCompareAtPrice(n, selectedDevice);

    price.textContent = `₪ ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    orig.textContent = `₪ ${compareAt.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
    step2.classList.add("completed");
    updateTickContent(step2, true);
  }
  // Show messages when there are remaining slots to fill (but not in unlimited mode)
  else if (remain > 0 && selectedPackSize < 999 && n <= 12) {
    // Hide device warning when showing other messages
    const deviceWarning = document.querySelector(".luuf-device-warning");
    if (deviceWarning) {
      deviceWarning.style.display = "none";
    }

    // Hide the error message - no need to show "select more flavors" text
    err.textContent = "";
    err.classList.remove("discount-upgrade");
    err.style.display = "none";

    // Cart should be enabled if at least 1 flavor is selected (allow purchase with 1/2 flavors)
    cart.disabled = !(n > 0);

    // Use simplified pricing
    const total = applySubscriptionDiscount(
      calculateFlavorPrice(n) + calculateDevicePrice(selectedDevice),
      n,
      selectedDevice
    );
    const compareAt = calculateCompareAtPrice(n, selectedDevice);

    price.textContent = `₪ ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    orig.textContent = `₪ ${compareAt.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
    step2.classList.add("completed");
    updateTickContent(step2, true);
  } else if (n > 12 && selectedPackSize < 999) {
    // More than 12 flavors selected but not in unlimited mode yet
    // For couple's pack + 12 months, only show unlimited when n > 24
    const shouldShowUnlimited =
      selectedDevice === "מארז זוגי" && selectedPackSize === 12
        ? n > 24 // Couple's pack + 12 months: allow up to 24 flavors
        : n > 12; // Regular pack: show unlimited after 12

    if (shouldShowUnlimited) {
      // Hide error, show unlimited text in summary
      const deviceWarning = document.querySelector(".luuf-device-warning");
      if (deviceWarning) {
        deviceWarning.style.display = "none";
      }
      err.style.display = "none";
      err.classList.remove("discount-upgrade");

      // Hide mobile prompt completely
      const promptWarning = document.querySelector(".luuf-prompt-warning");
      const typePrompt = document.querySelector(".luuf-type-selection-prompt");
      if (promptWarning) {
        promptWarning.style.display = "none";
      }
      if (typePrompt) {
        typePrompt.classList.remove("show");
      }

      // Cart should be enabled
      cart.disabled = false;

      // Use simplified pricing
      const total = applySubscriptionDiscount(
        calculateFlavorPrice(n) + calculateDevicePrice(selectedDevice),
        n,
        selectedDevice
      );
      const compareAt = calculateCompareAtPrice(n, selectedDevice);

      price.textContent = `₪ ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      orig.textContent = `₪ ${compareAt.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
      step2.classList.add("completed");
      updateTickContent(step2, true);
    } else {
      // Not showing unlimited yet - treat like normal selection with remaining slots
      const deviceWarning = document.querySelector(".luuf-device-warning");
      if (deviceWarning) {
        deviceWarning.style.display = "none";
      }
      err.style.display = "none";
      err.classList.remove("discount-upgrade");

      // Hide mobile prompt completely
      const promptWarning = document.querySelector(".luuf-prompt-warning");
      const typePrompt = document.querySelector(".luuf-type-selection-prompt");
      if (promptWarning) {
        promptWarning.style.display = "none";
      }
      if (typePrompt) {
        typePrompt.classList.remove("show");
      }

      // Cart should be enabled
      cart.disabled = false;

      // Use simplified pricing
      const total = applySubscriptionDiscount(
        calculateFlavorPrice(n) + calculateDevicePrice(selectedDevice),
        n,
        selectedDevice
      );
      const compareAt = calculateCompareAtPrice(n, selectedDevice);

      price.textContent = `₪ ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      orig.textContent = `₪ ${compareAt.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
      step2.classList.add("completed");
      updateTickContent(step2, true);
    }
  } else if (remain === 0 && n > 0) {
    // Hide device warning when pack is complete
    const deviceWarning = document.querySelector(".luuf-device-warning");
    if (deviceWarning) {
      deviceWarning.style.display = "none";
    }

    // Hide error message when pack is complete
    err.style.display = "none";
    err.classList.remove("discount-upgrade");

    // Also hide mobile prompt completely when pack is complete
    const promptWarning = document.querySelector(".luuf-prompt-warning");
    const typePrompt = document.querySelector(".luuf-type-selection-prompt");
    if (promptWarning && !(!selectedPeriod || !selectedDevice)) {
      promptWarning.style.display = "none";
    }
    if (typePrompt && selectedPeriod && selectedDevice) {
      typePrompt.classList.remove("show");
    }

    cart.disabled = false;

    // Use simplified pricing
    const total = applySubscriptionDiscount(
      calculateFlavorPrice(n) + calculateDevicePrice(selectedDevice),
      n,
      selectedDevice
    );
    const compareAt = calculateCompareAtPrice(n, selectedDevice);

    price.textContent = `₪ ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    orig.textContent = `₪ ${compareAt.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
    step2.classList.add("completed");
    updateTickContent(step2, true);
  } else {
    // Check if device is selected but no flavors are chosen yet
    if (selectedDevice && n === 0) {
      err.textContent = `בחרו טעמים עבור תקופת ${selectedPeriod} לפני הוספה לעגלה`;
      err.classList.remove("discount-upgrade");
      err.style.display = "block";
      cart.disabled = true;
      price.textContent = orig.textContent = "₪ 0.00";
      step2.classList.remove("completed");
      updateTickContent(step2, false);
    } else {
      // Hide error message
      err.style.display = "none";
      err.classList.remove("discount-upgrade");

      // Also hide mobile prompt completely
      const promptWarning = document.querySelector(".luuf-prompt-warning");
      const typePrompt = document.querySelector(".luuf-type-selection-prompt");
      if (promptWarning && !(!selectedPeriod || !selectedDevice)) {
        promptWarning.style.display = "none";
      }
      if (typePrompt && selectedPeriod && selectedDevice) {
        typePrompt.classList.remove("show");
      }
    }

    cart.disabled = false;
  }

  const txt = document.querySelector(".luuf-summary-count");

  // Calculate effective pack size and remaining flavors (same calculation as above)
  let effectivePackSizeForDisplay = selectedPackSize;
  if (selectedDevice === "מארז זוגי" && selectedPackSize > 0) {
    effectivePackSizeForDisplay = selectedPackSize * 2; // Double the flavors for couple's pack
  }
  const remainForDisplay = effectivePackSizeForDisplay ? Math.max(effectivePackSizeForDisplay - n, 0) : 0;

  // Show count text based on flavor count and selected period
  if (selectedPeriod && selectedPackSize > 0) {
    // For couple's pack + 12 months, only show unlimited when n > 24
    const shouldShowUnlimited =
      selectedPackSize >= 999 || (selectedDevice === "מארז זוגי" && selectedPackSize === 12 ? n > 24 : n > 12);

    if (shouldShowUnlimited) {
      // Unlimited mode or more than limit flavors selected
      txt.textContent = `${n} טעמים נבחרו (ללא הגבלה)`;
    } else {
      // Show count with remaining flavors text if there are remaining slots
      // Also show target when device and period are selected, even if no flavors yet
      if ((remainForDisplay > 0 || n === 0) && selectedPackSize < 999 && selectedPeriod && selectedDevice) {
        const couplePackText = selectedDevice === "מארז זוגי" ? " (מארז זוגי - x2 טעמים)" : "";
        if (n === 0) {
          // Show target when no flavors selected yet
          txt.innerHTML = `0 טעמים נבחרו<br><span style="font-size: 0.85em; color: #d33;">חסר עוד ${effectivePackSizeForDisplay} טעמים להשלמת חבילת ${selectedPackSize} חודשים${couplePackText}</span>`;
        } else {
          txt.innerHTML = `${n} טעמים נבחרו<br><span style="font-size: 0.85em; color: #d33;">חסר עוד ${remainForDisplay} טעמים להשלמת חבילת ${selectedPackSize} חודשים${couplePackText}</span>`;
        }
      } else {
        txt.textContent = `${n} טעמים נבחרו`;
      }
    }
  } else {
    txt.textContent = `${n} טעמים נבחרו`;
  }
  txt.style.color = "var(--green)";
  txt.style.fontWeight = "600";
}

/* ---------- CART FUNCTIONALITY ---------- */
function buildCartItems() {
  const items = [];

  // Add device variant
  if (selectedDevice && DEVICE_VARIANT_IDS[selectedDevice]) {
    items.push({
      id: DEVICE_VARIANT_IDS[selectedDevice],
      quantity: 1,
    });
  }

  // Add flavor variants
  $all(".luuf-flavour").forEach((card) => {
    const qtySpan = card.querySelector(".luuf-count");
    if (qtySpan) {
      const qty = +qtySpan.textContent;
      if (qty > 0) {
        items.push({
          id: card.dataset.variantId,
          quantity: qty,
        });
      }
    }
  });

  return items;
}

async function handleAddToCart(e) {
  e.preventDefault();

  const addToCartButton = e.target.closest(".luuf-addcart");
  const originalText = addToCartButton.innerHTML;
  const originalStyle = addToCartButton.style.cssText;

  // Show loading state - only the loading text centered
  addToCartButton.classList.add("loading");
  addToCartButton.innerHTML = "<span>מוסיף לעגלה...</span>";
  addToCartButton.disabled = true;

  try {
    let items = buildCartItems();

    // --- DISCOUNT LOGIC ---
    // Every /discount/ call costs close to a second, so only request the codes this
    // order actually needs. The two flavour tiers are mutually exclusive, and codes
    // already on the cart stay applied, so both are usually skippable.
    // ?redirect=/cart.js keeps each response near 1.5KB instead of a full page render.
    const currentCart = await fetch("/cart.js").then((r) => r.json());
    const appliedCodes = (currentCart.discount_codes || []).map((d) => d.code);

    // Count flavours already in the cart so a second add still reaches the right tier
    const flavorVariantIds = $all(".luuf-flavour").map((card) => card.dataset.variantId);
    const flavorsInCart = (currentCart.items || [])
      .filter((item) => flavorVariantIds.includes(String(item.variant_id)))
      .reduce((sum, item) => sum + item.quantity, 0);
    const flavorCount = getTotalFlavors() + flavorsInCart;

    const wantedCodes = [];
    if (flavorCount >= 12) {
      wantedCodes.push("12+ טעמים");
    } else if (flavorCount >= 6) {
      wantedCodes.push("6 טעמים");
    }
    // 10% off the order in exchange for starting the monthly subscription
    if (getSubscriptionToggle()) {
      wantedCodes.push(SUBSCRIPTION_DISCOUNT_CODE);
    }

    // One at a time: concurrent discount requests race each other and can empty the cart
    for (const code of wantedCodes) {
      if (appliedCodes.includes(code)) continue;
      await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart.js`);
    }

    // Find the last flavor item (to be added via button click - only 1 unit)
    let lastFlavorItem = null;
    let lastFlavorIndex = -1;

    // Find the index of the last flavor (not device) in items array
    for (let i = items.length - 1; i >= 0; i--) {
      const item = items[i];
      // Check if this is a flavor item (not a device)
      const isDevice = Object.values(DEVICE_VARIANT_IDS).includes(item.id);
      if (!isDevice) {
        lastFlavorItem = { ...item, quantity: 1 }; // Only 1 unit for button click
        lastFlavorIndex = i;
        break;
      }
    }

    // Add gift product based on selected period
    const periodNumber = selectedPackSize >= 999 ? 12 : selectedPackSize; // Use 12 for unlimited mode
    const giftVariantId = GIFT_VARIANT_IDS[periodNumber];
    if (giftVariantId) {
      items.push({
        id: giftVariantId,
        quantity: 1,
      });
    }

    // Add the monthly subscription when its checkbox is ticked, unless the cart is
    // already subscribed. Reuses currentCart so the common path costs no extra request.
    // Pushed after lastFlavorIndex is resolved so it is never mistaken for a flavor.
    const existingSubLine = findSubscriptionLine(currentCart, getSubscriptionVariantId());
    const subToggle = existingSubLine ? null : getSubscriptionToggle();
    if (subToggle) {
      const subItem = {
        id: subToggle.dataset.variantId,
        quantity: 1,
      };
      if (subToggle.dataset.sellingPlanId) {
        subItem.selling_plan = +subToggle.dataset.sellingPlanId;
      }
      items.push(subItem);
    }

    // Separate items: all except 1 unit of last flavor go via API
    let itemsForApi = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (i === lastFlavorIndex) {
        // For the last flavor, add all except 1 (which will go via button click)
        if (item.quantity > 1) {
          itemsForApi.push({
            id: item.id,
            quantity: item.quantity - 1,
          });
        }
        // If quantity is 1, don't add to API (it goes via button click)
      } else {
        // Add all other items normally
        itemsForApi.push(item);
      }
    }

    // Add all items except last flavor via API
    if (itemsForApi.length > 0) {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items: itemsForApi,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    // Now add the last flavor by clicking the button (this will open the cart drawer)
    if (lastFlavorItem) {
      // Find the flavor card with this variant ID
      const flavorCard = document.querySelector(`.luuf-flavour[data-variant-id="${lastFlavorItem.id}"]`);

      if (flavorCard) {
        // Find the product form button for this flavor and click it
        // We need to use the hidden cart form approach - set the variant and click
        const hiddenCartButton = document.getElementById(
          "quick-add-template--52581791072416__main52581791072416-submit",
        );

        if (hiddenCartButton) {
          // Find the hidden input for variant ID and set it
          const form = hiddenCartButton.closest("form");
          if (form) {
            const variantInput = form.querySelector('input[name="id"]');
            if (variantInput) {
              variantInput.value = lastFlavorItem.id;
            }
            // Set quantity
            const qtyInput = form.querySelector('input[name="quantity"]');
            if (qtyInput) {
              qtyInput.value = lastFlavorItem.quantity;
            }
          }

          console.log("Clicking button for last flavor:", lastFlavorItem.id);
          hiddenCartButton.click();
        }
      }
    } else {
      // No flavor items, just click the button to open cart
      const hiddenCartButton = document.getElementById("quick-add-template--52581791072416__main52581791072416-submit");
      if (hiddenCartButton) {
        hiddenCartButton.click();
      }
    }

    // Reset button state after successful operation (but don't clear selections)
    addToCartButton.innerHTML = originalText;
    addToCartButton.style.cssText = originalStyle;
    addToCartButton.classList.remove("loading");
    addToCartButton.disabled = !selectedPeriod || !selectedDevice;
  } catch (error) {
    console.error("Error adding to cart:", error);

    // Show error message to user
    const errorElement = document.querySelector(".luuf-error");
    errorElement.textContent = "שגיאה בהוספה לעגלה. נסה שוב.";
    errorElement.style.display = "block";

    // Reset button state
    addToCartButton.innerHTML = originalText;
    addToCartButton.style.cssText = originalStyle;
    addToCartButton.classList.remove("loading");
    addToCartButton.disabled = !selectedPeriod || !selectedDevice;
  }
}

/* ---------- MOBILE BAR ---------- */
function initMobileBar() {
  const bar = document.querySelector(".luuf-checkout");
  const typeSelectionPrompt = document.querySelector(".luuf-type-selection-prompt");
  let shown = false;
  let promptShown = false;

  const onScroll = () => {
    if (innerWidth <= MOBILE_BREAKPOINT) {
      const s = scrollY > SCROLL_THRESHOLD;

      // Show add to cart if flavors section is opened and user has selected period and device
      if (flavorsSectionOpened && selectedPeriod && selectedDevice) {
        if (s && !shown) {
          bar.classList.add("show");
          shown = true;
        }
        if (!s && shown) {
          bar.classList.remove("show");
          shown = false;
        }
        // Hide prompt when showing add to cart
        if (promptShown) {
          typeSelectionPrompt.classList.remove("show");
          promptShown = false;
        }
      }
      // Show type selection prompt if user hasn't selected period or device but scrolled enough
      else if (s && (!selectedPeriod || !selectedDevice)) {
        if (!promptShown) {
          typeSelectionPrompt.classList.add("show");
          promptShown = true;
        }
        // Hide add to cart if it was shown
        if (shown) {
          bar.classList.remove("show");
          shown = false;
        }
      }
      // Also show type selection prompt if flavors are selected but period/device missing (even if not scrolled)
      else if (flavorsSectionOpened && (!selectedPeriod || !selectedDevice)) {
        const n = getTotalFlavors();
        if (n > 0) {
          if (!promptShown) {
            typeSelectionPrompt.classList.add("show");
            promptShown = true;
          }
          // Hide add to cart if it was shown
          if (shown) {
            bar.classList.remove("show");
            shown = false;
          }
        }
      } else {
        // Hide both if not scrolled enough
        if (shown) {
          bar.classList.remove("show");
          shown = false;
        }
        if (promptShown) {
          typeSelectionPrompt.classList.remove("show");
          promptShown = false;
        }
      }
    } else {
      // On desktop, hide both
      if (shown) {
        bar.classList.remove("show");
        shown = false;
      }
      if (promptShown) {
        typeSelectionPrompt.classList.remove("show");
        promptShown = false;
      }
    }
  };
  addEventListener("scroll", onScroll, { passive: true });
  addEventListener("resize", onScroll);
  onScroll();
  setTimeout(onScroll, 100);
}

/* ---------- SCROLL TO TYPE SELECTION ---------- */
function scrollToTypeSelection() {
  // Determine which section to scroll to based on what's missing
  let targetSection;
  if (!selectedPeriod) {
    targetSection = document.querySelector("#luuf-step1");
  } else if (!selectedDevice) {
    targetSection = document.querySelector("#luuf-step2");
  } else {
    targetSection = document.querySelector("#luuf-step1"); // Default to period selection
  }

  if (targetSection) {
    // Calculate the target scroll position to center the section on screen
    const sectionHeight = targetSection.offsetHeight;
    const windowHeight = window.innerHeight;
    const targetScrollTop = targetSection.offsetTop - windowHeight / 2 + sectionHeight / 2;

    // Smooth scroll to the calculated position
    window.scrollTo({
      top: targetScrollTop,
      behavior: "smooth",
    });

    // Add glance effect after scroll completes
    // Use a more reliable method to detect when scroll finishes
    let scrollCheckInterval;
    const checkScrollComplete = () => {
      if (Math.abs(window.pageYOffset - targetScrollTop) < 5) {
        clearInterval(scrollCheckInterval);

        // Add a subtle shiny wave animation to draw attention
        targetSection.style.animation = "glanceEffect 0.8s ease-out";

        // Remove the animation after it completes
        setTimeout(() => {
          targetSection.style.animation = "";
        }, 800);
      }
    };

    // Check every 50ms if scroll has completed
    scrollCheckInterval = setInterval(checkScrollComplete, 50);
  }
}

/* ---------- UPDATE TYPE SELECTION PROMPT ---------- */
function updateTypeSelectionPrompt() {
  const promptButton = document.querySelector(".luuf-type-prompt-btn");
  const deviceWarning = document.querySelector(".luuf-device-warning");
  const promptWarning = document.querySelector(".luuf-prompt-warning");

  if (!promptButton) return;

  if (selectedPeriod && selectedDevice) {
    // Both period and device are selected - hide the prompt completely
    document.querySelector(".luuf-type-selection-prompt").classList.remove("show");
  } else if (getTotalFlavors() > 0) {
    // Flavors selected but missing period or device - show appropriate prompt
    if (!selectedPeriod) {
      promptButton.textContent = "לחצו כאן לבחירת תקופת גמילה";
    } else if (!selectedDevice) {
      promptButton.textContent = "לחצו כאן לבחירת סוג";
    }
    if (deviceWarning) {
      deviceWarning.style.display = "block";
    }
    if (promptWarning) {
      promptWarning.style.display = "block";
    }
  } else {
    // No period, device, or flavors - show original prompt
    promptButton.textContent = "לחצו כאן כדי להפסיק לעשן!";
    if (deviceWarning) {
      deviceWarning.style.display = "none";
    }
    if (promptWarning) {
      promptWarning.style.display = "none";
    }
  }
}

/* ---------- TRIGGER MOBILE BAR UPDATE ---------- */
function triggerMobileBarUpdate() {
  if (innerWidth <= MOBILE_BREAKPOINT) {
    // Force a scroll event to trigger the mobile bar logic
    window.dispatchEvent(new Event("scroll"));
  }
}

/* ---------- INIT ---------- */
addEventListener("load", () => {
  // Load saved state first

  /* open accordion panels marked expanded in markup */
  $all('.luuf-toggle[aria-expanded="true"]').forEach((btn) => {
    const p = document.querySelector(btn.dataset.target);
    if (btn.dataset.target === "#luuf-step1") {
      p.style.maxHeight = "none";
      p.style.padding = "0 0 0";
    } else if (btn.dataset.target === "#luuf-step2") {
      p.style.maxHeight = "none";
      p.style.padding = "0 0 0";
    } else if (btn.dataset.target === "#luuf-step3") {
      p.style.maxHeight = "none";
      p.style.padding = "0 0 8px";
    }
  });

  initAccordion();
  initPeriodSelect();
  initDeviceSelect();
  initFlavorDelegation();
  initMobileBar();
  generateFlavorsFromData();

  // Restore period selection UI
  if (selectedPeriod) {
    const periodCards = document.querySelectorAll("#luuf-step1 .luuf-device");
    periodCards.forEach((card) => {
      const title = card.querySelector("h4").textContent;
      if (title === selectedPeriod) {
        periodCards.forEach((c) => {
          c.classList.remove("selected");
          const b = c.querySelector("button");
          b.textContent = b.textContent.replace("נבחר", "בחירה");
        });
        card.classList.add("selected");
        const btn = card.querySelector("button");
        btn.textContent = btn.textContent.replace("בחירה", "נבחר");
        const step1 = document.querySelector('[data-target="#luuf-step1"]');
        const step1Text = step1.querySelector(".step-text");
        if (step1Text) {
          step1Text.textContent = `1. בחירת תקופת גמילה - ${selectedPeriod}`;
        }
        step1.classList.add("completed");
        updateTickContent(step1, true);
      }
    });
  }

  // Restore device selection UI
  if (selectedDevice) {
    const deviceCards = document.querySelectorAll("#luuf-step2 .luuf-device");
    deviceCards.forEach((card) => {
      const title = card.querySelector("h4").textContent;
      if (title === selectedDevice) {
        deviceCards.forEach((c) => {
          c.classList.remove("selected");
          const b = c.querySelector("button");
          b.textContent = b.textContent.replace("נבחר", "בחירה");
        });
        card.classList.add("selected");
        const btn = card.querySelector("button");
        btn.textContent = btn.textContent.replace("בחירה", "נבחר");
        const step2 = document.querySelector('[data-target="#luuf-step2"]');
        const step2Text = step2.querySelector(".step-text");
        if (step2Text) {
          step2Text.textContent = `2. בחירת סוג - ${selectedDevice}`;
        }
        step2.classList.add("completed");
        updateTickContent(step2, true);
      }
    });
  }

  // Ensure both panels are open by default
  flavorsSectionOpened = true;

  updateSummary();
  updateTypeSelectionPrompt();

  // Add event listener for add to cart button
  document.querySelector(".luuf-addcart").addEventListener("click", handleAddToCart);

  // Keep the total in sync with the monthly subscription checkbox
  const subToggleEl = document.getElementById("luuf-sub-toggle");
  if (subToggleEl) {
    subToggleEl.addEventListener("change", updateSummary);
  }

  // Trigger mobile bar update to ensure correct state on page load
  setTimeout(triggerMobileBarUpdate, 200);

  // Ensure flavors section is considered open from the start
  setTimeout(() => {
    flavorsSectionOpened = true;
    triggerMobileBarUpdate();
    updateTypeSelectionPrompt();
  }, 300);

  // Add event listener for type selection prompt button
  document.querySelector(".luuf-type-prompt-btn").addEventListener("click", scrollToTypeSelection);

  // Add event listener for page refresh to clear state (optional)
  // Uncomment the next line if you want to clear state on page refresh
  // window.addEventListener('beforeunload', clearState);
});

addEventListener("pageshow", () => {
  const addToCartButton = document.querySelector(".luuf-addcart");
  if (addToCartButton) {
    addToCartButton.classList.remove("loading");
    addToCartButton.disabled = false;
    addToCartButton.innerHTML = `<span class='luuf-summary-text'><span>הוספה לעגלה 👉🏻</span></span><span class='luuf-summary-prices' dir='rtl' style='display: flex; align-items: center; gap: 8px;'><span class='luuf-summary-price'>₪ 0.00</span><span class='luuf-summary-original'>₪ 0.00</span></span>`;
    addToCartButton.disabled = !selectedPeriod || !selectedDevice;
  }

  // Trigger mobile bar update to ensure correct state on page show
  setTimeout(triggerMobileBarUpdate, 100);
});
